module.exports = {
  "country": "HR",
  "artist": "Jacques Houdek",
  "song": "My Friend",
  "year": "2017",
  "place": "13",
  "spotify": "184cjXwukXedpuWm4Xl6X7"
};